import { visit } from 'unist-util-visit';
import { TAG_MAP } from './constants';

export function remarkCustomContainer() {
  return (tree: any) => {
    // 递归处理所有容器节点
    visit(tree, 'containerDirective', (node: any) => {
      // 处理当前容器节点
      const tagName = TAG_MAP[node.name as keyof typeof TAG_MAP];
      if (tagName) {
        const data = node.data || (node.data = {});
        data.hName = tagName; // 渲染成 Tag 组件
        data.hProperties = {
          ...node.attributes, // 把 directive 上的属性注入到 props
        };
      }
    });
  };
}

export function removeFootnotes() {
  return (tree: any) => {
    visit(tree, (node, index, parent) => {
      if (
        node.type === 'footnoteDefinition' ||
        node.type === 'footnoteReference' ||
        node.type === 'footnote'
      ) {
        if (parent && typeof index === 'number') {
          parent.children.splice(index, 1);
        }
      }
    });
  };
}
